/**
 * Validates a single field in the Acknowledgements form.
 * @param {string} name - Field name
 * @param {any} value - Field value
 * @returns {string|null} - Error message or null if valid
 */
const validateAttested = (value) => {
  if (!value) {
    return "You must attest to the statement above";
  }
  return null;
};

const validateAdvocateName = () => {
  // Optional field
  return null;
};

const validateAdvocateEmail = (value) => {
  if (value?.trim()) {
    const emailRegex = /^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/;
    if (!emailRegex.test(value)) {
      return "Please enter a valid email address";
    }
  }
  return null;
};

const validateAdvocatePhone = (value) => {
  if (value?.trim()) {
    const digitsOnly = value.replaceAll(/\D/g, "");
    if (digitsOnly.length !== 10) {
      return "Please enter a valid 10-digit phone number";
    }
  }
  return null;
};

export const validateAcknowledgementField = (name, value) => {
  switch (name) {
    case "attested":
      return validateAttested(value);
    case "advocateName":
      return validateAdvocateName();
    case "advocateEmail":
      return validateAdvocateEmail(value);
    case "advocatePhone":
      return validateAdvocatePhone(value);
    default:
      return null;
  }
};

/**
 * Validates the entire Acknowledgements form data.
 * @param {object} data - Acknowledgements data
 * @returns {object} - Object containing errors for each field
 */
export const validateAcknowledgementsForm = (data) => {
  const errors = {};
  const fields = ["attested", "advocateName", "advocateEmail", "advocatePhone"];

  fields.forEach((field) => {
    const error = validateAcknowledgementField(field, data[field]);
    if (error) errors[field] = error;
  });

  return errors;
};
